exports.components = {
  "component---src-components-dev-doc-template-index-tsx": () => import("./../../../src/components/DevDocTemplate/index.tsx" /* webpackChunkName: "component---src-components-dev-doc-template-index-tsx" */),
  "component---src-page-404-tsx": () => import("./../../../src/page/404.tsx" /* webpackChunkName: "component---src-page-404-tsx" */)
}

